import up from "../assets/walkers/up.png";
import down from "../assets/walkers/down.png";
import nochange from "../assets/walkers/nochange.png";

import COSTS from "./allCosts";

// sizes for mana cost icons
const iconWidth = 25;
const iconHeight = 25;
const costWidth = 72;
const costHeight = 52;
const costHeightOffset = 38;

const loyaltyIndent = 70;
const loyaltyX = 0;

const walkerBuilder = (oracle, font, costFont, width, height) => {
  //console.log(`Drawing orace : ${oracle}`);
  // line stuff
  const lineHeight = 25;
  const lineBreak = 45;
  const canvas = document.createElement("canvas");
  canvas.height = height;
  canvas.width = width;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  //ctx.fillRect(0, 0, canvas.width, canvas.height);

  ctx.fillStyle = "#000000";
  ctx.font = font;
  const images = [];
  // split oracle text into lines

  if (oracle.length > 0) {
    // abilities are split by newlines
    const lines = oracle.split("\n");

    const costHeightOffset = lines[0].indexOf(":") > -1 ? 23 : 38;
    let currentY = lineBreak;
    lines.forEach((line) => {
      const loyaltyCost = line.substring(0, line.indexOf(":") + 2);
      // account for static abilities
      if (loyaltyCost.length > 2) {
        line = line.replace(loyaltyCost, "");
        images.push({
          isCost: true,
          cost: loyaltyCost.replace(": ", ""),
          yPos: currentY - costHeightOffset,
          xPos: loyaltyX,
          width: costWidth,
          height: costHeight,
        });
      }
      if (line.search(/{*}/) > -1) {
        // handle ones with cost
        let currentX = loyaltyIndent;
        // space out all costs
        line = line.replace(/{.}/g, " $& ");
        let words = line.split(" ");
        let idx = 1;
        while (words.length > 0 && idx <= words.length) {
          const thisWord = words[idx - 1];
          // check if this word is a cost
          if (thisWord.search(/{.}/) === 0) {
            if (idx !== 1) {
              // if this isn't the first word in the line draw what we have.
              const printString = words.slice(0, idx - 1).join(" ");
              const textWidth = ctx.measureText(printString).width;
              ctx.fillText(printString, currentX, currentY);
              // update text offset
              currentX = currentX + textWidth + 2;
              // update words
              words = words.splice(idx - 1);
            }
            // add image to the list of images to draw
            images.push({
              isCost: false,
              imgSrc: COSTS[thisWord],
              xPos: currentX + 3,
              yPos: currentY - iconHeight + 4,
              width: iconWidth,
              height: iconHeight,
            });
            // update x offset
            currentX = currentX + iconWidth + 4;
            // remove the icon from the array
            words = words.splice(1);
            // move on to next word
            idx = 1;
          } else {
            const toPrint = words.slice(0, idx).join(" ");
            const printedWidth = currentX + ctx.measureText(toPrint).width;
            if (printedWidth > width) {
              // adjust for last word on its own line.
              if (idx === 1) {
                idx = 2;
              }
              // remove the last word and draw
              ctx.fillText(
                words.slice(0, idx - 1).join(" "),
                currentX,
                currentY
              );
              // update stuff
              words = words.splice(idx - 1);
              currentY = currentY + lineHeight;
              currentX = loyaltyIndent;
              idx = 1;
            } else {
              // go to next word
              idx++;
            }
          }
          // print whatever is in the array
        }
        ctx.fillText(words.slice(0, idx).join(" "), currentX, currentY);
        // shift by linebreak ever new ability
        currentY = currentY + lineBreak;
      } else {
        // split line into words
        let words = line.split(" ");
        let idx = 1;
        while (words.length > 0 && idx <= words.length) {
          // recreate the line one word at a time and check if fits
          const toPrint = words.slice(0, idx).join(" ");
          const printedWidth = ctx.measureText(toPrint).width + loyaltyIndent;
          if (printedWidth > width) {
            // adjust for last word on its own line.
            if (idx === 1) {
              idx = 2;
            }
            // remove the last word and draw
            ctx.fillText(
              words.slice(0, idx - 1).join(" "),
              loyaltyIndent,
              currentY
            );
            // update stuff
            words = words.splice(idx - 1);
            currentY = currentY + lineHeight;
            idx = 1;
          } else {
            // go to next word
            idx++;
          }
        }
        // print whatever is in the array
        ctx.fillText(words.slice(0, idx).join(" "), loyaltyIndent, currentY);
        // shift by linebreak every new ability
        currentY = currentY + lineBreak;
      }
    });
  }

  // return everything as promises to make loading easier
  if (images.length === 0) {
    // if no images to load just send it back
    return new Promise((resolve, reject) => {
      resolve(canvas.toDataURL("image/png"));
    });
  } else {
    // wait for all loads to resolve
    return Promise.all(
      images.map((image) => {
        return new Promise((resolve, reject) => {
          const img = document.createElement("img");
          if (image.isCost) {
            //console.log(`Cost is '${image.cost}'`);
            if (image.cost.indexOf("+") === 0) {
              img.src = up;
            } else if (image.cost.indexOf("−") === 0) {
              img.src = down;
            } else {
              img.src = nochange;
            }
          } else {
            img.src = image.imgSrc;
          }
          img.addEventListener("load", () => resolve(img));
        });
      })
    )
      .then((imgs) => {
        // draw all the images to the canvas
        imgs.forEach((img, idx) => {
          ctx.drawImage(
            img,
            images[idx].xPos,
            images[idx].yPos,
            images[idx].width,
            images[idx].height
          );
          if (images[idx].isCost) {
            ctx.fillStyle = "#FFF";
            ctx.font = costFont;
            const costString =
              images[idx].cost === "0"
                ? ` ${images[idx].cost}`
                : images[idx].cost;
            ctx.fillText(
              costString,
              images[idx].xPos + 18,
              images[idx].yPos + costHeightOffset - 2
            );
          }
        });
        // return the canvas
        return canvas.toDataURL("image/png");
      })
      .catch((e) => console.error(`Some error with drawing oracle ${e.stack}`));
  }
};

export default walkerBuilder;
